export default class RavMesserApi {
    constructor(base) {
        this.base = base;
        this.baseUrl = this.base.cfg.VUE_APP_TRANSACTIONS_API_BASE_ADDRESS;
        this.ravMesserIntegrationUrl = this.baseUrl + '/api/integrations/rav-messer';
    }

    async getLists(terminalID) {
        let response = await this.base.get(this.ravMesserIntegrationUrl + '/lists', { terminalID });
        return response || { lists: [] };
    }
}
